import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PackContents, MethodOverview } from './components/MethodOverview';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-12 md:py-20 text-center pt-[4px] pb-[4px]" data-id="element-0" data-mp="31c9ygdv1bhw7">
    <p className="text-xl md:text-3xl font-display italic text-brand-purpleDark/85 leading-relaxed font-[800]" data-id="element-1" data-mp="2wj8g1vvmd07v">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen bg-brand-surface font-sans text-brand-text selection:bg-brand-purple/25 selection:text-brand-purpleDark" data-id="element-2" data-mp="23v2rey1g2r2r">
      <div className="pointer-events-none fixed inset-0 -z-10 reiki-pattern opacity-[0.025]" aria-hidden="true" data-id="element-3" data-mp="3mlawr57iwbsx" />
      <UrgencyBanner data-id="element-4" data-mp="3rbrbqtqzs5he" />
      <Hero data-id="element-5" data-mp="3rdki07xp0nov" />
      <PackContents data-id="element-6" data-mp="3rcswjpxt86cb" />
      <InitialTestimonials data-id="element-7" data-mp="3recbnd7qcbci" />
      <PainPoints data-id="element-8" data-mp="5opiv1o0k3w" />
      <MethodOverview data-id="element-9" data-mp="682rygdekbl" />
      <MoreTestimonials data-id="element-10" data-mp="5ggje8nxyxz" />
      <Guarantee data-id="element-11" data-mp="7sulgbavp5r" />
      <FAQ data-id="element-12" data-mp="2zld0z6e9z99y" />
      <CostComparison data-id="element-13" data-mp="2zllduyaeeel5" />
      <TransitionPhrase data-id="element-14" data-mp="2zmepodo7rua5" />
      <EmotionalClose data-id="element-15" data-mp="2zmwh8wzxlkbq" />
      <Footer data-id="element-16" data-mp="33mov9p83gioh" />
      <FloatingNotification data-id="element-17" data-mp="33mf6g4yschkd" />
    </div>;
}